import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import * as i18IsoCountries from 'i18n-iso-countries';
import { Observable, of, switchMap } from 'rxjs';

import { Country } from '../state/countries.models';

@Injectable()
export class CountriesService {
  private http = inject(HttpClient);

  getCountries(localeId: string): Observable<Country[]> {
    if (this.isLocaleRegistered(localeId)) {
      return this.countriesFromRegisteredLocale(localeId);
    } else {
      return this.countriesFromNewLocale(localeId);
    }
  }

  private isLocaleRegistered(localeId: string): boolean {
    return Object.keys(i18IsoCountries.getNames(localeId)).length > 0;
  }

  private countriesFromRegisteredLocale(localeId: string): Observable<Country[]> {
    return of(
      Object.entries(i18IsoCountries.getNames(localeId, { select: 'official' })).map(([id, name]) => ({
        id,
        name,
      }))
    );
  }

  private countriesFromNewLocale(localeId: string): Observable<Country[]> {
    return this.http.get<i18IsoCountries.LocaleData>(`assets/i18n-iso-countries/${localeId}.json`).pipe(
      switchMap((localeData) => {
        i18IsoCountries.registerLocale(localeData);
        return this.countriesFromRegisteredLocale(localeId);
      })
    );
  }
}
